module.exports = "<svg id=\"f45a2c26-68e5-4508-b81e-b88b9256cee6\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 27.78\"><title>graduation</title><path d=\"M25,0,0,9.44l25,9.45L50,9.44ZM2.78,11.67v4.68a2.69,2.69,0,0,1,2.22,0V12.5Zm6.66,2.51v8c0,2.33,6.94,5.56,15.56,5.56s15.56-3.23,15.56-5.56v-8L25.4,19.91a1.1,1.1,0,0,1-.8,0L9.44,14.18Zm-5.55,3a1.67,1.67,0,1,0,1.67,1.67A1.67,1.67,0,0,0,3.89,17.22Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/graduation.svg
// module id = 564
// module chunks = 1